export default __webpack_public_path__ + "static/media/GF.462caa7b.svg";